export interface Product {
  productName: string;
  productUseCases: string;
  productReports: string;
  productHowWorks: string;
  productImage: string;
  productId: number;
  productFragment: string;
}

export const productsOfferingData: Product[] = [
  {
    productName: 'products_page.products.traffic_analytics',
    productUseCases: 'products_page.traffic_analytics.productUseCases',
    productReports: 'products_page.traffic_analytics.productReports',
    productHowWorks: 'products_page.traffic_analytics.productHowWorks',
    productImage: 'Traffic-analytics.svg',
    productId: 1,
    productFragment: 'traffic-analytics',
  },
  {
    productName: 'products_page.products.queue_occupancy',
    productUseCases: 'products_page.queue_mangement.productUseCases',
    productReports: 'products_page.queue_mangement.productReports',
    productHowWorks: 'products_page.queue_mangement.productHowWorks',
    productImage: 'Queue-management.svg',
    productId: 2,
    productFragment: 'queue-management',
  },
  {
    productName: 'products_page.products.journey_analytics',
    productUseCases: 'products_page.journey_analytics.productUseCases',
    productReports: 'products_page.journey_analytics.productReports',
    productHowWorks: 'products_page.journey_analytics.productHowWorks',
    productImage: 'Journey-analytics.png',
    productId: 4,
    productFragment: 'journey-analytics',
  },
];
